<div class="bg-fieldset mt-2 px-4 py-2">
  <h2 class="text-lg font-bold mb-4">Documents</h2>
  
  <div class="flex flex-col lg:flex-row gap-6">
    
    <div class="flex flex-col w-full lg:w-1/2">
      
      <div class="w-full mb-4">
        <mat-label class="block mb-1 font-medium">{{isSupreme() ? 'Select Appeal Number': 'Select Case Number'}}</mat-label>
        <mat-form-field class="w-full ncms-case-number-field" appearance="outline">
          <mat-select [ngModel]="selectedCase()?.id" 
                      [hideSingleSelectionIndicator]="true" 
                      (selectionChange)="caseChangeHandler($event)">
            @for(mc of motionCases(); track mc.id) {
              <mat-option [value]="mc.id">{{mc.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div>
        <h2 class="text-md font-semibold mb-2">Documents List</h2>
        <mat-accordion [multi]="true" class="w-full">
          @if (motionCaseDocs()) {
            @for(caseDocs of motionCaseDocs() | keyvalue; track caseDocs.key) {
              <mat-expansion-panel class="mb-2 border border-accent">
                <mat-expansion-panel-header>
                  <mat-panel-title class="font-medium">
                    {{caseDocs.key}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                
                <div class="overflow-x-auto w-full">
                  @if (caseDocs.value.length) {
                    <table mat-table [dataSource]="caseDocs.value" class="w-full min-w-[300px]">
                      <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns; let $index = index;">
                        <th mat-header-cell *matHeaderCellDef class="bg-gray-100 font-bold px-2"> {{tblCols[column]}} </th>
                        <td mat-cell *matCellDef="let docItem; let idx = index" class="px-2 py-2">
                          
                          <ng-template [ngIf]="column == 'docName'" [ngIfElse]="defaultColumnViewRef">
                            <button mat-button color="primary" class="whitespace-normal text-left break-words"
                                    (click)="openAttachmentDialog(docItem)">
                              {{docItem[column]}}
                            </button>
                          </ng-template>
                          <ng-template #defaultColumnViewRef>{{idx + 1}}</ng-template>
                          
                        </td>
                      </ng-container>
                      
                      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                      <tr mat-row *matRowDef="let docItem; columns: displayedColumns;" class="hover:bg-gray-50"></tr>
                    </table>
                  }
                </div>
              </mat-expansion-panel>
            }
          }
        </mat-accordion>
      </div>
    </div>

    <div class="flex flex-col w-full lg:w-1/2 mt-4 lg:mt-0 lg:pt-1">
      <h2 class="text-lg font-bold mb-2">Comments</h2>
      <div class="px-4 py-4 bg-white rounded shadow-sm border border-gray-200">
        @for(item of comments(); track item.documentTypeName + item.comments + $index) {
          <div class="mb-4 pb-4 border-b border-gray-100 last:border-0 last:pb-0">
            <p class="text-sm md:text-base">
              <span class="font-semibold text-gray-800">{{item.documentTypeName}}</span>: 
              <span class="text-gray-700">{{item.comments}}</span>
            </p>
            @if (item.dateOfFiling) {
              <p class="text-xs text-gray-500 mt-1">{{item.dateOfFiling | date: 'mediumDate'}}</p>
            }
          </div>
        } @empty {
          <p class="text-gray-500 italic">No comments available.</p>
        }
      </div>
    </div>

  </div>
</div>